export default __webpack_public_path__ + "static/media/barra.81b06ae3.jpg";